export default __webpack_public_path__ + "static/suppliersBY-1e51f6bd1c2784ea97d161a2c6386a1e.jpg";